import React from 'react';
import { QrCode, Eye, Download } from 'lucide-react';
import { COLORS } from '../../../../utils/constants';
import QRCode from 'react-qr-code';

const QRCodesSection = ({ settings, onPreview, onDownload }) => {
  const qrItems = [
    { key: 'usdt_trc20', label: 'USDT (TRC20)', address: settings?.deposit_address_usdt_trc20 },
    { key: 'usdt_erc20', label: 'USDT (ERC20)', address: settings?.deposit_address_usdt_erc20 },
    { key: 'btc', label: 'Bitcoin', address: settings?.deposit_address_btc },
    { key: 'eth', label: 'Ethereum', address: settings?.deposit_address_eth },
  ];

  return (
    <div style={{
      backgroundColor: COLORS.card,
      borderRadius: '12px',
      padding: '20px',
      border: `1px solid ${COLORS.border}`,
      marginBottom: '16px',
    }}>
      <h3 style={{ color: COLORS.text, fontSize: '16px', fontWeight: '600', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <QrCode size={20} color={COLORS.primary} />
        QR-коды кошельков
      </h3>
      <p style={{ color: COLORS.textSecondary, fontSize: '13px', marginBottom: '20px' }}>
        QR-коды автоматически генерируются из адресов выше. Нажмите для предпросмотра и скачивания.
      </p>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
        {qrItems.map(({ key, label, address }) => (
          <div key={key} style={{
            backgroundColor: COLORS.background,
            borderRadius: '10px',
            padding: '16px',
            textAlign: 'center',
          }}>
            <div style={{ color: COLORS.text, fontSize: '13px', fontWeight: '600', marginBottom: '12px' }}>
              {label}
            </div>
            
            {address ? (
              <>
                <div style={{
                  backgroundColor: '#fff',
                  padding: '12px',
                  borderRadius: '8px',
                  display: 'inline-block',
                  marginBottom: '12px',
                  cursor: 'pointer',
                }} onClick={() => onPreview({ currency: label, address })}>
                  <QRCode
                    id={`qr-${key}`}
                    value={address}
                    size={100}
                    level="H"
                    fgColor="#000000"
                    bgColor="#ffffff"
                  />
                </div>
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                  <button
                    onClick={() => onPreview({ currency: label, address })}
                    style={{
                      padding: '6px 10px',
                      backgroundColor: `${COLORS.primary}20`,
                      border: 'none',
                      borderRadius: '6px',
                      color: COLORS.primary,
                      fontSize: '11px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    <Eye size={12} /> Открыть
                  </button>
                  <button
                    onClick={() => onDownload(address, label)}
                    style={{
                      padding: '6px 10px',
                      backgroundColor: `${COLORS.success}20`,
                      border: 'none',
                      borderRadius: '6px',
                      color: COLORS.success,
                      fontSize: '11px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    <Download size={12} /> PNG
                  </button>
                </div>
              </>
            ) : (
              <div style={{ color: COLORS.textSecondary, fontSize: '12px', padding: '40px 0' }}>
                Адрес не указан
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QRCodesSection;
